export default __webpack_public_path__ + "static/bakula-150x150-ad915b22d61ddcf251818dd52c0f5489.png";